import { render, staticRenderFns } from "./mail-to-list.vue?vue&type=template&id=29a11256&scoped=true"
import script from "./mail-to-list.vue?vue&type=script&lang=js"
export * from "./mail-to-list.vue?vue&type=script&lang=js"
import style0 from "./mail-to-list.vue?vue&type=style&index=0&id=29a11256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a11256",
  null
  
)

export default component.exports